// extracted by mini-css-extract-plugin
export default {"control":"control_control__6DCkl","button":"control_button__w+kDM"};